import { IChangeListItemAdditionalServiceProps } from "./ChangeListItemTypes"

import { Text, Flex, Center } from "@chakra-ui/react"

const ChangeListItemAdditionalService: React.FC<IChangeListItemAdditionalServiceProps> = ({ title, value }) => {
  const services = value.split("\n")

  return (
    <>
      <Text mb={"8px"} fontSize="base">
          {title}
      </Text>
      <Flex padding={"16px"} borderRadius={"10px"} align={"center"} justifyContent="center" bgColor={"#fff"}>
        {services.map((service, i)=>(
          <Center 
            border="1px solid" 
            borderColor="primary"
            key={service} 
            padding="10px" 
            fontSize="base" 
            borderRadius="base"
            mr={i !== services.length - 1 ? "5px": ""}
          >
            {service}
          </Center>
        ))}
      </Flex>
    </>
  )
}

export default ChangeListItemAdditionalService